import React from "react";
import moment from "moment";
import { inject, observer } from "mobx-react";
import { Button, Modal, Label, Grid, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import ListSearch from "../components/bucket/ListSearch";
import { ExportSubFunction } from "../constants/constants-container";
import { NavigationTabs } from "../components/navigation/NavigationTabs";
import { StoreContext } from "../contexts/StoreContext";
import MaintenanceAgencyLabel from "../components/detail/MaintenanceAgencyLabel";

import "./EntityDetailsModal.scss";
import PreviewPage from "../pages/PreviewPage/PreviewPage";

@inject(
  "previewStore",
  "exportImportStore",
  "popupStore",
  "navigationStore",
  "searchStore"
)
@observer
export default class EntityDetailsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      variableDetails: {},
    };
  }
  exportToExcel = () => {
    const { entityData, frameworkRelated } = this.props;
    const {
      func_handleExportClick,
      handleSelectedCubesChange,
      handleSelectedVariableChange,
      changeSelectedExportSubFunction,
      handleSelectedFrameworksChange,
    } = this.props.exportImportStore;

    const data = entityData;

    const variable = this.props.variable.object;

    let cube = "";
    if (data && data.item && data.item.object) {
      cube = data.item.object;
    }

    changeSelectedExportSubFunction(
      ExportSubFunction.INDIVIDUAL_VARIABLE_EXPORT
    );
    handleSelectedVariableChange(variable);
    handleSelectedCubesChange(cube);
    handleSelectedFrameworksChange([frameworkRelated])
    func_handleExportClick();
  };
  async componentDidMount() {
    const {
      details,
      popupStore,
      frameworkRelated,
      CubeStructureItemData,
      validityDate,
    } = this.props;
    const { getFrameworks } = this.props.searchStore;
    if (frameworkRelated) {
      const frameworks = getFrameworks;
      let frameworkName = frameworks.find(
        (it) => it.frameworkId === frameworkRelated
      );
      this.props.searchStore.setSearchFramework(frameworkName);
    }

    const tidToUse = details.object ? details.object.tid : details.tid;
    const typeToUse = details.object ? details.object.type : details.type;

    if (
      CubeStructureItemData?.object?.type === "CubeStructureItem" &&
      typeToUse === "Variable"
    ) {
      popupStore.setParentEntityTidByType({
        CubeStructureItem: CubeStructureItemData?.object?.tid,
      });
    }
    if (typeToUse.toLowerCase() === "subdomain" || "Variableset") {
      popupStore.setValidityDate(validityDate);
    }

    popupStore.initAdditionalQueryParams(typeToUse);
    popupStore.fetchEntityDetails(typeToUse, tidToUse, null, (entityData) => {
      this.setState({
        variableDetails:
          entityData.item.navigationLookupResult.navigationLookupRootItem,
      });
    });
  }

  componentDidUpdate = async () => {
    const {
      fetchEntityDetails,
      initAdditionalQueryParams,
      setDisplayPublishedCubesOfFramework,
      setPrevTid,
      setPrevType,
      setCanRefresh,
      canRefresh,
      type,
      prevTid,
      tid,
    } = this.context;
    if (type && type.toLowerCase() === "framework") {
      setDisplayPublishedCubesOfFramework(this.readPublishedUrlParam());
    }

    if (tid !== prevTid && type && tid && canRefresh) {
      initAdditionalQueryParams(type);
      fetchEntityDetails(type, tid);
      setCanRefresh(false);
      setPrevType(type);
      setPrevTid(tid);
    }
  };
  helper_findCubeStructure(item) {
    if (item?.object?.type === "CubeStructure") {
      return item;
    } else {
      if (item.items)
        // check if cube structure exists, it can happen it does not if validity ranges are not valid
        for (const element of item.items) {
          const currentChild = element;
          const result = this.helper_findCubeStructure(currentChild);
          if (result !== false) {
            return result;
          }
        }
    }
    return false;
  }
  componentWillUnmount() {
    this.props.popupStore.setSearchMatrix("VariableDetailModal", "");
    this.props.popupStore.setParentEntityTidByType(null);
  }

  getTitle(item) {
    const { setType, setTid } = this.props.popupStore;
    const titleItems = [];

    if (!item) {
      return "null";
    }

    if (item.name) {
      titleItems.push(
        <Link
          key="title-name"
          onClick={(e) => {
            e.preventDefault();
            this.handleClickScroll();
            setType(item.type);
            setTid(item.tid);
          }}
          to={`/view/${item.type}/${item.tid}`}
          className="object-name"
        >
          {item.name}
        </Link>
      );
    }
    if (item.legalCode) {
      titleItems.push(
        <Link
          key="title-legalCode"
          onClick={(e) => {
            e.preventDefault();
            this.handleClickScroll();
            setType(item.type);
            setTid(item.tid);
          }}
          to={`/view/${item.type}/${item.tid}`}
          className="object-name"
        >
          {item.legalCode}
        </Link>
      );
    }
    if (item.code) {
      titleItems.push(`(${item.code})`);
    }
    titleItems.push(
      <Label key="title-type" className="object-type" bsStyle="success">
        {item.type}
      </Label>
    );
    if (item.maintenanceAgencyId) {
      titleItems.push(
        <MaintenanceAgencyLabel
          maintenanceAgencyId={item.maintenanceAgencyId}
          key={item.tid}
        />
      );
    }

    return titleItems;
  }

  getValidity(obj) {
    return (
      obj.validFrom &&
      obj.validTo && (
        <div className="validity-container">
          <p>
            <b>Valid From: </b>
            {moment(obj.validFrom).format("YYYY-MM-DD")}
            <b>Valid To: </b>
            {moment(obj.validTo).format("YYYY-MM-DD")}
          </p>
        </div>
      )
    );
  }
  handleClickScroll = () => {
    const element = document.getElementById("Scroll-to-here");
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  static contextType = StoreContext;
  render() {
    const { cubeVariableName, cubeVariableCode, onClose } = this.props;
    const { resetNavigationTabs } = this.props.navigationStore;
    const { variableDetails } = this.state;

    if (
      JSON.stringify(variableDetails) === "{}" ||
      variableDetails === undefined ||
      !variableDetails?.object?.type
    )
      return null;

    const type = variableDetails?.object?.type;
    let title =
      type !== "Member" && type !== "Variable"
        ? `${cubeVariableName} (${cubeVariableCode})`
        : "";

    return (
      <Modal
        show={true}
        onHide={(e) => {
          this.props.onClose(e);
          resetNavigationTabs();
        }}
        dialogClassName="VariableDetailsModal related-types-list cube-structure-item"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {title}
          </Modal.Title>
        </Modal.Header>
        {this.renderModalBody(type)}

        <Modal.Footer>
          {type.toLowerCase() === "subdomain" ||
          type.toLowerCase() === "variableset" ? (
            <Button onClick={this.exportToExcel}>Export</Button>
          ) : null}
          <Button
            onClick={(e) => {
              resetNavigationTabs();
              onClose(e);
              this.props.popupStore.clearEntityData();
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderModalBody = (type) => {
    const lowerCasedType = type.toLowerCase()

    if (lowerCasedType === "subdomain") {
      return this.subdomainModalBody()
    }

    if (lowerCasedType === "variableset") {
      return this.variableSetModalBody()
    }

    return (
      <Modal.Body>
        <StoreContext.Provider value={this.props.popupStore}>
          <PreviewPage></PreviewPage>
        </StoreContext.Provider>
      </Modal.Body>
    )
  }

  subdomainModalBody = () => {
    const {items, totalCount, hasFacet} = this.getFilteredSubdomainItemData()

    return (
      <Modal.Body>
        {this.modalBodyDescription()}
        {hasFacet && items
          .sort((a, b) => a?.code?.localeCompare(b?.code))
          .map((detailSubitem, index) => {
            return (
              detailSubitem.facetValueType && (
                <div
                  style={{ marginTop: "10px", marginBottom: "10px" }}
                  key={detailSubitem.tid ?? index}
                >
                  <strong>Value Type:</strong>{" "}
                  {detailSubitem.facetValueType}
                </div>
              )
            );
          })}
        <div className="custom-panel">
          <div className="custom-panel-heading">
            <h4>{hasFacet ? "Constraints" : "Allowed values"}</h4>
          </div>
          <div className="custom-panel-body">
            {totalCount === 0 && "No Constraint defined"}
            {totalCount > 1 && (
              <ListSearch
                searchMatrixKey={"VariableDetailModal"}
                placeholder={"Filter by Name or Code"}
              />
            )}
            <div className="item-list-container">
              {items
                .sort((a, b) => a.code.localeCompare(b.code))
                .map((detailSubitem, index) => (
                  <div key={index}>
                    <div>
                      <Grid fluid={true} style={{ paddingLeft: 0 }}>
                        <Row key={detailSubitem.name}>
                          <Col xs={8}>
                            <div className="related-types-list">
                              {this.getTitle(detailSubitem)}
                            </div>
                          </Col>
                          <Col xs={4}>
                            {this.getValidity(detailSubitem)}
                          </Col>
                        </Row>
                      </Grid>
                      {detailSubitem.facetEnumerations?.length > 0 ? (
                        <div className="container-fluid">
                          {detailSubitem.facetEnumerations.map(
                            (facetEnumeration, index) => (
                              <Row
                                key={index}
                                className="facets"
                                style={{
                                  marginBottom: "10px",
                                  borderTop:
                                    index !== 0 ? "1px solid #ddd" : "none",
                                }}
                              >
                                <div style={{ width: "100%" }}>
                                  <div className="col-xs-2">
                                    <strong>
                                      {facetEnumeration.facetType}
                                    </strong>
                                  </div>
                                  <div className="col-xs-10">
                                    {facetEnumeration.observationValue}
                                  </div>
                                  {facetEnumeration.facetType ===
                                    "pattern" && (
                                    <Row className="facets">
                                      <Col
                                        xs={12}
                                        style={{ marginLeft: "20px" }}
                                      >
                                        <div>
                                          If you want to understand regular
                                          expressions under <i>pattern</i>{" "}
                                          item(s), you can use e.g.{" "}
                                          <a
                                            className="pattern"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="https://regexr.com/"
                                          >
                                            https://regexr.com
                                          </a>
                                          . Copy and paste the value into
                                          respective expression input box.
                                          <br />
                                          <b>
                                            Disclaimer: The link refers to
                                            an external website for which we
                                            are not responsible.
                                          </b>
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                </div>
                              </Row>
                            )
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {!hasFacet && totalCount > 0 && (
          <div className="VariableDetailsModal__see-complete-list">
            Showing <strong>{items.length}</strong> out
            of <strong>{totalCount}</strong> items.
          </div>
        )}
        <StoreContext.Provider value={this.props.popupStore}>
          <div id="Scroll-to-here"></div>
          <NavigationTabs></NavigationTabs>
        </StoreContext.Provider>
      </Modal.Body>
    )
  }

  getFilteredSubdomainItemData = () => {
    const { variableDetails } = this.state;
    const subdomainItemData = []

    if (!variableDetails) {
      return []
    }

    let hasFacet = false;
    variableDetails.items.forEach((item) => {
      if (item.object.type === "SubdomainEnumeration") {
        const member = item.items.find((x) => x.object.type === "Member");
        if (member) {
          subdomainItemData.push({
            name: member?.object.name,
            type: member?.object.type,
            tid: member?.object.tid,
            code: member?.object.code,
            maintenanceAgencyId: member?.object?.maintenanceAgencyId,
            validFrom: item?.object?.validFrom,
            validTo: item?.object?.validTo,
          });
        }
      }

      if (item.object.type === "FacetCollection") {
        hasFacet = true
        subdomainItemData.push({
          tid: item?.object?.tid,
          facetValueType: item?.object?.facetValueType,
          facetEnumerations: item?.items // even facetEnumerations array can be undefined
            ? item.items
                .filter((x) => {
                  return x?.object?.type === "FacetEnumeration";
                })
                .map((x) => x?.object)
            : undefined,
        });
      }
    });
    return {items: this.filterItemData(subdomainItemData), totalCount: subdomainItemData.length, hasFacet};
  }

  variableSetModalBody = () => {
    const { setType, setTid } = this.props.popupStore
    const {items, totalCount} = this.getFilteredVariableSetItemData()

    return (
      <Modal.Body>
        <h4>Values restricted to</h4>
        {this.modalBodyDescription()}
        <div className="custom-panel">
          <div className="custom-panel-heading">
            <h4>{"Allowed values"}</h4>
          </div>
          <div className="custom-panel-body">
            {totalCount === 0 && "No Constraint defined"}
            {totalCount > 1 && (
              <>
                <ListSearch
                  searchMatrixKey={"VariableDetailModal"}
                  placeholder={"Filter by Name or Code"}
                />
              </>
            )}
            <div className="item-list-container">
              {items
                .sort((a, b) => a.code.localeCompare(b.code))
                .map((detailSubitem, index) => (
                  <div key={index}>
                    <div>
                      <Grid fluid={true} style={{ paddingLeft: 0 }}>
                        <Row key={detailSubitem.name}>
                          <Col xs={8}>
                            <div className="related-types-list">
                              {this.getTitle(detailSubitem)}
                            </div>
                          </Col>
                          <Col xs={4}>
                            {this.getValidity(detailSubitem)}
                          </Col>
                        </Row>
                      </Grid>
                      {detailSubitem.subdomain && (
                        <div
                          style={{
                            marginLeft: "25px",
                            marginBottom: "15px",
                          }}
                        >
                          <strong>With restriction:</strong>{" "}
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleClickScroll();
                              setType(detailSubitem.subdomain.type);
                              setTid(detailSubitem.subdomain.tid);
                            }}
                            to={`/view/${detailSubitem.subdomain.type}/${detailSubitem.subdomain.tid}`}
                          >
                            {`${
                              detailSubitem.subdomain.name || "[No name]"
                            } (${detailSubitem.subdomain.code})`}
                          </Link>
                          <Label className="object-type" bsStyle="success">
                            {detailSubitem.subdomain.type}
                          </Label>
                          {detailSubitem.subdomain.maintenanceAgencyId ? (
                            <MaintenanceAgencyLabel
                              maintenanceAgencyId={detailSubitem.subdomain.maintenanceAgencyId}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {totalCount > 0 && (
          <div className="VariableDetailsModal__see-complete-list">
            Showing <strong>{items.length}</strong> out
            of <strong>{totalCount}</strong> items.
          </div>
        )}
        <StoreContext.Provider value={this.props.popupStore}>
          <div id="Scroll-to-here"></div>
          <NavigationTabs></NavigationTabs>
        </StoreContext.Provider>
      </Modal.Body>
    )
  }

  getFilteredVariableSetItemData = () => {
    const { variableDetails } = this.state;
    if (!variableDetails) {
      return []
    }
    const variableSetItemData = variableDetails.items.map(variableSetEnumeration => {
      const subdomain = variableSetEnumeration.items ? variableSetEnumeration.items.find((x) => x.object.type === "Subdomain") : undefined;
      const variable = variableSetEnumeration.items ? variableSetEnumeration.items.find((x) => x.object.type === "Variable") : undefined;
      return {
        name: variable?.object?.name,
        type: variable?.object?.type,
        tid: variable?.object?.tid,
        code: variable?.object?.code,
        maintenanceAgencyId: variable?.object?.maintenanceAgencyId,
        validFrom: variableSetEnumeration?.object?.validFrom,
        validTo: variableSetEnumeration?.object?.validTo,
        subdomain: subdomain
          ? {
              name: subdomain.object?.name,
              type: subdomain.object?.type,
              tid: subdomain.object?.tid,
              code: subdomain.object?.code,
              maintenanceAgencyId: subdomain.object?.maintenanceAgencyId,
            }
          : undefined,
      };
    });
    return {items: this.filterItemData(variableSetItemData), totalCount: variableSetItemData.length};
  }

  filterItemData = (itemsData) => {
    const searchExpr = this.props.popupStore.getSearchMatrix["VariableDetailModal"] || "";

    return searchExpr ? 
      itemsData.filter(item => (item?.name && item.name.toLowerCase().includes(searchExpr.toLowerCase())) || (item?.code && item.code.toLowerCase().includes(searchExpr.toLowerCase()))) : 
      itemsData;
  }

  modalBodyDescription = () => {
    const { clearEntityData } = this.props.previewStore;
    const { resetNavigationTabs } = this.props.navigationStore;
    const { variableDetails } = this.state;

    return (
      <>
        <h4>Values restricted to</h4>
        <div>
          <p>
            <Link
              onClick={(e) => {
                resetNavigationTabs();
                clearEntityData();
              }}
              to={`/view/${variableDetails.object.type}/${variableDetails.object.tid}`}
            >
              {`${variableDetails.object.name || "[No name]"}`}
            </Link>
            {` (${variableDetails.object.code}) `}
            <Label className="object-type" bsStyle="success">
              {variableDetails.object.type}
            </Label>
            {variableDetails.object.maintenanceAgencyId ? (
              <MaintenanceAgencyLabel
                maintenanceAgencyId={variableDetails.object.maintenanceAgencyId}
              />
            ) : (
              ""
            )}
          </p>
          <p>{variableDetails.object.description || "[No description]"}</p>
        </div>
      </>
    )
  }
}
